<template>
  <b-card class="bg-white rounded-xl px-2">
    <!-- <AddBannerPopup :isOpen="isPopupOpen" @close="togglePopup" /> -->
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Partners</h2>
      </div>
      <div class="flex items-center gap-4">
        <base-button
          outline
          class="px-6 py-1 mx-1"
          type="primary"
          @click="handleAdd"
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
          </span>
        </base-button>
      </div>
    </div>
    <BannerTable />
  </b-card>
</template>

<script>
import BannerTable from "./components/bannerTable.vue";
import AddBannerPopup from "./components/AddBannerPopup.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    BannerTable,
    AddBannerPopup,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addPartners" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
</style>
